// derived from private\component-react\packages\image-experience-utils\src\get-smart-cropped-image.js
// and remvoed unrelated code/logic, only keep smart cropping handling here

import _ from 'underscore';
import { getCentralCroppedPlacements } from '@bingads-webui-campaign-react/unified-ad-preview-library-core';
import { validateSmartCropSettings } from '@bingads-webui-campaign/image-experience-utils';

export const getSmartCropSettingsFactory = (mediaRepository, smartCropActivity) => {
  //
  // todo: defaultOption & isIncluded?
  const getSmartCropSettings = ({ imageMeta, imageCropping, placementMetaList }) => {
    // if the image is cropped itself, use central cropping for placements intead of smart cropping
    if (imageCropping) {
      return getCentralCroppedPlacements({ imageMeta, imageCropping, placementMetaList });
    }

    const ratioAndMinSizeList = _.map(placementMetaList, (placementMeta) => {
      const { aspectRatio, minSize } = placementMeta;
      return { aspectRatio, minSize };
    });

    return mediaRepository.generateSmartCrop({
      imageUrl: imageMeta.originalUrl,
      placementSettings: ratioAndMinSizeList, // [{aspectRatio, minSize}]
    }).then((assets) => {
      const ret = _.map(placementMetaList, (placementMeta) => {
        const asset = _.find(assets, ({ AspectRatio }) => AspectRatio === placementMeta.aspectRatioStr);
        if (asset) {
          const smartCropping = {
            SourceWidth: asset.Width,
            SourceHeight: asset.Height,
            SourceX: asset.X,
            SourceY: asset.Y,
          };
          const isValidSmartCropping = validateSmartCropSettings({
            originalImage: { width: imageMeta.originalWidth, height: imageMeta.originalHeight, Src: imageMeta.originalUrl },
            cropSettings: smartCropping,
            minWidth: placementMeta.minSize[0],
            minHeight: placementMeta.minSize[1],
            aspectRatio: placementMeta.aspectRatio,
            smartCropActivity,
          });
          return { placementMeta, smartCropping: isValidSmartCropping ? smartCropping : null };
        }
        return { placementMeta, smartCropping: null };
      });
      return ret; // [{placementMeta, smartCropping, isValidCropping}]
    }).catch(() => {
      // swallow the error
    }).then((smartPlacementAndCroppingList) => {
      // fallback to central cropped placements if no smart cropping available for some placements
      const placementsWithoutSmartCropping = _.filter(smartPlacementAndCroppingList, ({ smartCropping }) => !smartCropping);
      let croppingList = null;
      if (!_.isEmpty(placementsWithoutSmartCropping)) {
        const centralCroppingList = getCentralCroppedPlacements({ imageMeta, imageCropping, placementMetaList });
        // merge central cropping with smart cropping, smart cropping has high priority
        croppingList = _.map(smartPlacementAndCroppingList, ({ smartCropping }, idx) => (smartCropping ? { placementCropping: smartCropping } : centralCroppingList[idx]));
      } else {
        croppingList = _.map(smartPlacementAndCroppingList, ({ smartCropping }) => ({ placementCropping: smartCropping }));
      }
      return croppingList;
    });
  };

  return getSmartCropSettings;
};
